export enum Color {
	RED = '#e72341',
	ORANGE = '#ff9d34',
	YELLOW = '#ffeb00',
	GREEN = '#82bc00',
}
